import { useState, type FormEvent } from 'react'
import { useSession } from '../session.tsx'
import { errorMessage } from '../lib/useResource.ts'
import { Button, Card, PageTitle, Paragraph, TextField } from '../components/ui.tsx'
import { Brand, PasswordField } from '../components/bits.tsx'

export function LoginPage() {
  const { login } = useSession()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(email, password)
    } catch (err) {
      setError(errorMessage(err))
      setBusy(false)
    }
  }

  return (
    <div className="app-shell">
      <div className="page">
        <main className="page-content auth-page">
          <Brand />
          <PageTitle title="Přihlášení" size="hero" />
          <Card>
            <form className="stack" onSubmit={(e) => void submit(e)}>
              <TextField
                label="E-mail"
                type="email"
                inputMode="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <PasswordField
                label="Heslo"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {error && <Paragraph tone="error">{error}</Paragraph>}
              <Button kind="primary" type="submit" full disabled={busy}>
                {busy ? 'Přihlašuji…' : 'Přihlásit se'}
              </Button>
            </form>
          </Card>
          <Paragraph size="meta">
            Účet se zakládá přes pozvánku od někoho ze skupiny. Zapomenuté heslo obnoví ten, kdo aplikaci spravuje.
          </Paragraph>
        </main>
      </div>
    </div>
  )
}
